import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Resume.scss';
import { experience } from '../experience/data';
import anishPhoto from '../../assets/photo.jpeg';

const Resume = () => {
    const navigate = useNavigate();
    const [includePhoto, setIncludePhoto] = useState(true);

    useEffect(() => {
        const previousTitle = document.title;
        const metaDescription = document.querySelector('meta[name="description"]');
        const previousDescription = metaDescription?.getAttribute('content') ?? '';

        const resumeTitle = 'Anish Lawrence — Resume | Senior Frontend Developer & Open Source Builder';
        const resumeDescription =
            'Printable resume: 8+ years frontend engineering, AniUI founder (149 React Native components), Workato & DeepConverse AI product experience. React, TypeScript, design systems.';

        document.title = resumeTitle;
        if (metaDescription) {
            metaDescription.setAttribute('content', resumeDescription);
        }

        return () => {
            document.title = previousTitle || 'Anish Lawrence — Senior Frontend Developer & Open Source Builder';
            if (metaDescription && previousDescription) {
                metaDescription.setAttribute('content', previousDescription);
            }
        };
    }, []);

    const handlePrint = () => {
        window.print();
    };

    const handleBackToHome = () => {
        navigate('/');
    };

    return (
        <div className={`resume-page ${includePhoto ? '' : 'resume-no-photo'}`}>
            <div className="resume-action-buttons no-print">
                <label className="photo-toggle">
                    <input
                        type="checkbox"
                        checked={includePhoto}
                        onChange={(e) => setIncludePhoto(e.target.checked)}
                    />
                    Include photo
                </label>
                <button className="back-button" onClick={handleBackToHome}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Back to Home
                </button>
                <button className="print-button" onClick={handlePrint}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M6 9V2H18V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M6 18H4C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16V11C2 10.4696 2.21071 9.96086 2.58579 9.58579C2.96086 9.21071 3.46957 9 4 9H20C20.5304 9 21.0391 9.21071 21.4142 9.58579C21.7893 9.96086 22 10.4696 22 11V16C22 16.5304 21.7893 17.0391 21.4142 17.4142C21.0391 17.7893 20.5304 18 20 18H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M18 14H6V22H18V14Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Print / Save as PDF
                </button>
            </div>

            <div className="resume-container">
                {/* Header */}
                <header className="resume-header">
                    <div className="header-left">
                        <div className="header-content">
                            <h1 className="resume-name">Anish Lawrence</h1>
                            <p className="resume-title">Senior Frontend Developer & Open Source Builder</p>
                        </div>
                        <div className="header-contact">
                            <div className="contact-item">
                                <svg className="contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                                    <polyline points="22,6 12,13 2,6"/>
                                </svg>
                                <a href="mailto:anishlp7@gmail.com" className="contact-value contact-link">anishlp7@gmail.com</a>
                            </div>
                            <div className="contact-item">
                                <svg className="contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                                </svg>
                                <a href="tel:+919043571929" className="contact-value contact-link">+91 9043571929</a>
                            </div>
                            <div className="contact-item">
                                <svg className="contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                                    <circle cx="12" cy="10" r="3"/>
                                </svg>
                                <span className="contact-value">Tamil Nadu, India</span>
                            </div>
                            <div className="contact-item">
                                <svg className="contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10"/>
                                    <line x1="2" y1="12" x2="22" y2="12"/>
                                    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                                </svg>
                                <a href="https://anishl-portfolio.vercel.app/" target="_blank" rel="noopener noreferrer" className="contact-value contact-link">anishl-portfolio.vercel.app</a>
                            </div>
                            <div className="contact-item">
                                <svg className="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                                </svg>
                                <a href="https://www.linkedin.com/in/anishlawrence/" target="_blank" rel="noopener noreferrer" className="contact-value contact-link">linkedin.com/in/anishlawrence</a>
                            </div>
                            <div className="contact-item">
                                <svg className="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                                </svg>
                                <a href="https://github.com/anishlp7" target="_blank" rel="noopener noreferrer" className="contact-value contact-link">github.com/anishlp7</a>
                            </div>
                        </div>
                    </div>
                    <div className="header-right">
                        <div className="photo-container">
                            <img src={anishPhoto} alt="Anish Lawrence" className="profile-photo" />
                        </div>
                    </div>
                </header>

                {/* Professional Summary */}
                <div className="resume-div">
                    <h3 className="div-title">
                        <span className="title-icon">●</span>
                        Professional Summary
                    </h3>
                    <p className="summary-text">
                        Senior Frontend Developer with 8+ years building scalable web and mobile applications and a Master's in Computer Science.
                        Independent founder of the AniUI React Native design system (149 components; see Open Source section).
                        Currently at Workato; previously DeepConverse — AI chat UIs, LLM APIs (GPT/Claude) with streaming, LaunchDarkly rollouts, NX monorepos, and Chrome extensions.
                    </p>
                </div>

                {/* Technical Skills */}
                <div className="resume-div">
                    <h3 className="div-title">
                        <span className="title-icon">●</span>
                        Technical Skills
                    </h3>
                    <div className="skills-grid">
                        <div className="skill-group">
                            <strong>Web:</strong> React • TypeScript • Next.js • Vue.js • HTML5 • CSS3 • SASS • Performance • Micro-frontends
                        </div>
                        <div className="skill-group">
                            <strong>Mobile:</strong> React Native • Expo • NativeWind • Uniwind • rn-primitives • Mobile Design Systems
                        </div>
                        <div className="skill-group">
                            <strong>UI/State:</strong> Ant Design • Shadcn/ui • Tailwind CSS • React Flow • Zustand • Redux • Framer Motion
                        </div>
                        <div className="skill-group">
                            <strong>Tools:</strong> Git • NX Monorepo • @aniui/cli • Vite • Chrome Extensions • Jest • LaunchDarkly • CI/CD • WebSockets • LLM APIs
                        </div>
                    </div>
                </div>

                {/* Open Source & Products — independent of employer roles; placed high for skim value */}
                <div className="resume-div">
                    <h3 className="div-title">
                        <span className="title-icon">●</span>
                        Open Source & Products (Founder, independent)
                    </h3>
                    <div className="experience-item">
                        <div className="exp-header">
                            <div className="exp-left">
                                <h4 className="job-title">Creator — AniUI Ecosystem</h4>
                                <p className="company-name">Personal project · Evenings & weekends</p>
                            </div>
                            <div className="exp-right">
                                <span className="job-date">2025 - Present</span>
                            </div>
                        </div>
                        <ul className="resp-list">
                            <li>Built and maintain AniUI, an MIT-licensed React Native UI library with <strong>149 components</strong>, 15+ screen blocks, and docs at aniui.dev — shadcn/ui-style copy-paste ownership for mobile.</li>
                            <li>Shipped <strong>@aniui/cli</strong> (init, add, blocks, themes) with support for Expo SDK 53–57, bare RN 0.76+, NativeWind v4/v5, and Uniwind; published shadcn/RNR registry at aniui.dev/r.</li>
                            <li>Launched <strong>AniUI Pro</strong> (pro.aniui.dev) — premium React Native templates and boilerplates for auth, commerce, and dashboard flows.</li>
                            <li>Built <strong>AniUI Academy</strong> (academy.aniui.dev) — project-based courses with live code playgrounds, XP, and progress tracking.</li>
                            <li>Designed anishl.dev as the public hub for the ecosystem using Next.js 14, Tailwind CSS, and Framer Motion (open source).</li>
                        </ul>
                    </div>
                </div>

                {/* Professional Experience */}
                <div className="resume-div">
                    <h3 className="div-title">
                        <span className="title-icon">●</span>
                        Professional Experience
                    </h3>
                    {experience.map((exp, index) => (
                        <div key={exp.id} className="experience-item">
                            <div className="exp-header">
                                <div className="exp-left">
                                    <h4 className="job-title">{exp.jobTitle}</h4>
                                    <p className="company-name">{exp.companyName}</p>
                                </div>
                                <div className="exp-right">
                                    <span className="job-date">
                                        {exp.to ? `${exp.from} - ${exp.to}` : exp.from}
                                    </span>
                                </div>
                            </div>
                            
                            {exp.keyProjects && (
                                <div className="key-projects">
                                    <span className="projects-label">Key Projects:</span>
                                    {exp.keyProjects.map((project, idx) => (
                                        <span key={project.id} className="project-tag">
                                            {project.name} ({project.tech.join(', ')})
                                            {idx < exp.keyProjects.length - 1 && ' • '}
                                        </span>
                                    ))}
                                </div>
                            )}
                            
                            <ul className="resp-list">
                                {exp.description.slice(0, index < 2 ? 5 : 3).map((item) => (
                                    <li key={item.id}>{item.desc}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                {/* Education */}
                <div className="resume-div">
                    <h3 className="div-title">
                        <span className="title-icon">●</span>
                        Education
                    </h3>
                    <div className="education-section">
                        <div className="education-item">
                            <div className="edu-header">
                                <h4 className="degree">Master of Engineering (ME)</h4>
                                <span className="edu-date">2018 - 2020</span>
                            </div>
                            <p className="edu-institution">Anna University</p>
                            <p className="edu-major">Major: Computer Science and Engineering · Full-time program</p>
                        </div>
                        <div className="education-item">
                            <div className="edu-header">
                                <h4 className="degree">Bachelor of Engineering (BE)</h4>
                                <span className="edu-date">2014 - 2018</span>
                            </div>
                            <p className="edu-institution">Anna University</p>
                            <p className="edu-major">Major: Computer Science and Engineering</p>
                        </div>
                    </div>
                </div>

                {/* Languages */}
                <div className="resume-div">
                    <h3 className="div-title">
                        <span className="title-icon">●</span>
                        Languages
                    </h3>
                    <ul className="lang-list">
                        <li><strong>English:</strong> Full Professional Proficiency</li>
                        <li><strong>Tamil:</strong> Full Professional Proficiency</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Resume;

